export default "__VITE_ASSET__Dr9ceSFA__"